<template>
    <div
        class="bg-slate-700 flex items-center p-4 h-16 max-w-full border-0 border-b border-solid border-slate-800 shadow-xl backdrop-blur"
    >
        <slot></slot>
    </div>
</template>
<script setup></script>
